<template>
  <b-container class="container">
    <b-row class="loginContainer" align-h="center" align-v="center">
      <b-col :lg="6" class="loginWrapper p-4">
        <b-form @submit.stop.prevent="onSubmit">
          <b-alert :show="form.error.show" variant="danger">{{
            form.error.text
          }}</b-alert>
          <b-form-group id="input-group-1" label="Usuario" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="form.username"
              :state="validateState('username')"
              placeholder="Usuario"
              aria-describedby="input-username-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="input-username-feedback"
              >Este campo es obligatorio.</b-form-invalid-feedback
            >
          </b-form-group>

          <b-form-group
            id="input-group-2"
            label="Contraseña:"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              v-model="form.password"
              :state="validateState('password')"
              placeholder="Contraseña"
              type="password"
              aria-describedby="input-password-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="input-password-feedback"
              >Este campo es obligatorio.</b-form-invalid-feedback
            >
          </b-form-group>

          <b-form-group
            id="mfa-otp-code-group"
            label="Código MFA:"
            label-for="mfa-otp-code"
          >
            <b-form-input
              id="mfa-otp-code"
              v-model="form.totp"
              :state="validateState('totp')"
              placeholder="012345"
              aria-describedby="input-mfa-otp-code-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="input-mfa-otp-code-feedback"
              >Este campo es obligatorio.</b-form-invalid-feedback
            >
          </b-form-group>

          <b-button type="submit" variant="primary">Iniciar sesión</b-button>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { actions } from '@/admin/api.js';
import store from '@/admin/store.js';

export default {
  mixins: [validationMixin],
  validations: {
    form: {
      username: {
        required,
      },
      password: {
        required,
      },
      totp: {
        required,
      },
    },
  },
  name: 'LoginScreen',
  data() {
    return {
      form: {
        username: '',
        password: '',
        totp: '',

        error: {
          show: false,
          text: '',
        },
      },
      foods: [
        { text: 'Select One', value: null },
        'Carrots',
        'Beans',
        'Tomatoes',
        'Corn',
      ],
      show: true,
    };
  },
  created() {},
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      actions
        .postAuth({
          username: this.$v.form.username.$model,
          password: this.$v.form.password.$model,
          totp: this.$v.form.totp.$model,
        })
        .then((response) => {
          store.setAuth(
            true,
            response.data.token,
            response.data.role,
            response.data.locations
          );

          this.$router.replace({
            name:
              this.$route.params && this.$route.params.redirect
                ? this.$route.params.redirect
                : 'AdminMainScreen',
            params:
              this.$route.params && this.$route.params.params
                ? this.$route.params.params
                : {},
          });
          store.setOverlayShow(false);
          localStorage.setItem('token_a', response.data.token);
        })
        .catch((err) => {
          store.setOverlayShow(false);
          this.form.error.show = true;
          this.form.error.text = 'Datos incorrectos';
        });
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = '';
      this.form.name = '';
      this.form.food = null;
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
}
.loginContainer {
  height: 100%;
}
.loginWrapper {
  background-color: white;
  border-radius: 0.35rem;
}
</style>
